import { EmployeeAvailabilityService } from './../../../services/employeeAvailability.service';
import { IGetListParams } from './../../../base/base.service';
import { IEmployeeAvailability } from '../../../services/employeeAvailability.service';

class DashboardAvailableEmployeesController {
    private employeeAvailability: IEmployeeAvailability[];
    constructor(private EmployeeAvailabilityService: EmployeeAvailabilityService) {
        "ngInject";
    }

    public $onInit = () => {
        this.getEmployeeAvailability();
    }

    public getEmployeeAvailability = () => {
        const params: IGetListParams = {
            limit: 10,
            sortfield: 'createdOn',
            sortorder: 'desc'
        }
        this.EmployeeAvailabilityService.all(params).then((employeeAvailability) => {
            this.employeeAvailability = employeeAvailability;
        })
    }
}

export const dashboardAvailableEmployeesComponent = {
    controller: DashboardAvailableEmployeesController,
    template: require('./dashboardAvailableEmployees.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/availableEmployees/dashboardAvailableEmployees.component.ts